import styled from "styled-components";

const VerticalDivider = styled.span`
  height: 100px;
  width: 1px;
  background: var(--tertiary-font-color);
  display: inline-block;
  margin-top: 30px;
  /* margin-left: 15px; */
`;

export default VerticalDivider;
